export const NAME = 'cp:decision'

export type ConsentDecision = 'allow' | 'reject' | 'mixed'

export interface ConsentDecisionEvent {
    decision: ConsentDecision
}

export default function createEvent(decision: ConsentDecision) {
    return new CustomEvent<ConsentDecisionEvent>(NAME, {
        bubbles: true,
        composed: true,
        detail: {
            decision
        }
    })
}
